// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2OcbT","title":"card_title__3qh-P","inActive":"card_inActive__3p0Uu"};